import { render, staticRenderFns } from "./stats-habitats.vue?vue&type=template&id=1e801ee7"
import script from "./stats-habitats.vue?vue&type=script&lang=js"
export * from "./stats-habitats.vue?vue&type=script&lang=js"
import style0 from "./stats-habitats.vue?vue&type=style&index=0&id=1e801ee7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports